import PropTypes from 'prop-types';
import React from 'react';

import BrText from '@components/BrText';

export default function TextColumn({ cell }) {
  return (
    <div className="text-column" title={cell.value || ''}>
      <BrText>{cell.value || ''}</BrText>
    </div>
  );
}

TextColumn.propTypes = {
  cell: PropTypes.shape({
    value: PropTypes.string,
  }).isRequired,
};
